const mobMenu = {
    dropdowns: document.querySelectorAll('.jsNextLvl'),   
   
    init() {
        this.mobileMenuFn();     
     
    },
   
    createItem(menu, name) {
        const wrap = menu.querySelector('.jsSubmenuWrap');
  
        if (!wrap) {
            const ul = document.createElement("ul");
            ul.classList.add('jsSubmenuWrap', 'main-nav__lvl1__menu');
            ul.innerHTML = `<li class=" newlink main-nav__back"> 
                                <i class="far fa-chevron-left"></i>
                                <span>${name}</span>
                            </li>`;
            menu.prepend(ul);
        }
    },
    createEvent(item) {
        const el = item.querySelector(".newlink");
        el.addEventListener('click', (e) => {
            e.preventDefault();
            item.classList.remove('activeClass');
        });
    },
    mobileMenuFn() {
        this.dropdowns.forEach((item) => {
         
            const subMenu = item.nextElementSibling;
            item.addEventListener('click', (e) => {            
                e.preventDefault();      
                  
                this.createItem(subMenu, item.innerText);
                subMenu.classList.add('activeClass');
                this.createEvent(subMenu);
            
            });
        });
    }
   

}

export default mobMenu;